import React from 'react'
import Home from './Home';
import SpotToVisit from './SpotToVisit';
import PrimeMembership from './PrimeMembership';
import Leads from './Leads';
import FeaturedIn from './FeaturedIn';
import Testimonials from './Testimonials';
import BookRide from './BookRide';
import OnlineBook from './OnlineBook';
import DownloadApp from './DownloadApp';
import Service from './Service';

function Main() {
  return (
    <div>
      <Home />
      <SpotToVisit />
      <PrimeMembership />
      <BookRide />
      <OnlineBook />
      <Service /> 
      <Leads />
      <FeaturedIn/>
      <Testimonials />
      <DownloadApp />
    </div>
  )
};

export default Main;